import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTaskDataInUserGuide } from '../../hooks/task';
import { trackSectionView, trackUserInteraction } from '../../utils/usageTracker';
import { HUBSPOT_ERROR_STATUS_PAGE_URL } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskGroupErrorBanner = () => {
  const {
    hasErrored: errorLoadingTasks,
    groupKey
  } = useTaskDataInUserGuide();
  const [isAlertClosed, setAlertClosed] = useState(false);
  useEffect(() => {
    if (!errorLoadingTasks || isAlertClosed) {
      return;
    }
    trackSectionView('task group error banner', groupKey);
  }, [groupKey, errorLoadingTasks, isAlertClosed]);
  if (!errorLoadingTasks || isAlertClosed) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    onClose: () => {
      setAlertClosed(true);
      trackUserInteraction('task load error banner close click', groupKey);
    },
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.checklist.error.taskLoadingError.banner.title"
    }),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      message: "app.checklist.error.taskLoadingError.banner.message_jsx",
      options: {
        href: HUBSPOT_ERROR_STATUS_PAGE_URL,
        onClick: () => trackUserInteraction('task load error banner status click', groupKey),
        use: 'on-bright'
      }
    })
  });
};
export default TaskGroupErrorBanner;